import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c05b388"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dialog"
};
const _hoisted_2 = {
  key: 0,
  class: "footer"
};
import { ref } from 'vue';
const __default__ = {
  name: 'CommonDialog'
};
function setup(__props, {
  expose,
  emit
}) {
  const notification = ref(false);
  const handleClose = () => {
    notification.value = false;
  };
  const open = () => {
    notification.value = true;
  };
  const onClose = () => {
    emit('closeDialog');
  };
  expose({
    open,
    handleClose
  });
  return (_ctx, _cache) => {
    const _component_el_button = _resolveComponent("el-button");
    const _component_el_dialog = _resolveComponent("el-dialog");
    return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, _mergeProps({
      modelValue: notification.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => notification.value = $event),
      title: __props.dialogTitle,
      width: __props.dialogWidth,
      "destroy-on-close": true,
      "close-on-click-modal": false,
      "before-close": handleClose
    }, _ctx.$attrs, {
      onClose: onClose
    }), {
      footer: _withCtx(() => [__props.footerShow ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
        class: "cancle",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('closeDialog'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.cancelText), 1)]),
        _: 1
      }), _createVNode(_component_el_button, {
        loading: __props.loading,
        disabled: __props.loading,
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => _ctx.$emit('determine'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.okText), 1)]),
        _: 1
      }, 8, ["loading", "disabled"])])) : _createCommentVNode("", true)]),
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "center")]),
      _: 3
    }, 16, ["modelValue", "title", "width"])]);
  };
}
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogWidth: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    footerShow: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    }
  },
  emits: ['determine', 'closeDialog'],
  setup
});